import { useEffect } from 'react';
import { Input } from 'antd';

const { TextArea } = Input;

const OrgJsonEditor = ({
  initialJson = {},
  setJsonInput,
  jsonInput,
  isValidJson,
  setIsValidJson,
  errorMessage,
  setErrorMessage,
}) => {
  // Set default JSON value
  useEffect(() => {
    if (initialJson) {
      if (Object?.keys(initialJson).length === 0) {
        setJsonInput(jsonInput);
      } else {
        setJsonInput(JSON.stringify(initialJson, null, 2));
      }
    }
  }, [initialJson, jsonInput, setJsonInput]);

  function handleBlur() {
    try {
      setIsValidJson(true);
      setErrorMessage('');
    } catch (error) {
      setIsValidJson(false);
      setErrorMessage('Invalid JSON format');
    }
  }

  const handleChange = (e) => {
    const updatedJson = e.target.value;
    setJsonInput(updatedJson);
  };

  return (
    <div style={{ position: 'relative' }}>
      {!isValidJson && (
        <div
          style={{
            color: 'red',
            position: 'absolute',
            top: '3px',
            right: '10px',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 1,
            padding: '4px',
            boxSizing: 'border-box',
            borderRadius: '4px',
          }}
        >
          {errorMessage}
        </div>
      )}
      <div className="h-[35rem] border-2 border-[#ccc] rounded-lg mt-4">
        <div className="grid grid-cols-1 gap-4">
          <TextArea
            bordered={false}
            rows={24}
            style={{
              resize: 'none',
              fontFamily: 'Poppins',
              position: 'relative',
              zIndex: 0,
            }}
            value={jsonInput ? jsonInput : ''}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
      </div>
    </div>
  );
};

export default OrgJsonEditor;
